import { Input } from "@/components/atoms/Input";
import usePersistent from "@/hooks/use-persistent";
import { useDebounce } from "use-debounce";
import ArchivedCandidatesTable from "./ArchivedExamsTable/ArchivedCandidatesTable";

const ArchivedCandidates = () => {
  const [searchText, setSearchText] = usePersistent(
    "administration-archived-candidates-searchText",
    ""
  );
  const [debouncedSearchText] = useDebounce(searchText, 300);

  return (
    <div className="flex flex-col gap-6 h-full w-full">
      <h2>Candidats archivés</h2>
      <Input
        className="shadow-none"
        id="shadcn-input"
        searchIcon
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value as string)}
        placeholder="Rechercher"
      />
      <ArchivedCandidatesTable searchText={debouncedSearchText} />
    </div>
  );
};

export default ArchivedCandidates;
